import React, { createContext, useContext, useState } from 'react'
import cn from 'classnames'
import { ButtonDep as Button, IconButton } from '..'
import { Fade } from 'react-reveal'

export interface BannerProps {
  announcement: {
    title: string
    text: string
    link: {
      url: string
    }
  }
}

const AnnouncementContext = createContext<{
  visible: boolean
  closeBanner: () => void
  Banner: ({ announcement }: BannerProps) => JSX.Element | null
}>({
  visible: true,
  closeBanner() {},
  Banner: () => <></>
})

const AnnouncementProvider: React.FC = ({ children }) => {
  const [visible, setVisible] = useState(true)

  const closeBanner = () => {
    setVisible(false)
  }

  const animDelay = 1000

  const Banner = ({ announcement }: BannerProps) =>
    visible ? (
      <div className='banner'>
        <div className='container h-100'>
          <Fade delay={animDelay * 0.8}>
            <div
              className={cn('banner__content', {
                'banner__content--visible': visible
              })}
            >
              <div className='position-relative d-flex w-100 h-100 align-items-center'>
                <Fade left distance='25px' delay={animDelay} duration={250}>
                  <div className='d-flex align-items-center banner__content__text'>
                    <h5 className='pr-2'>{announcement.title}</h5>
                    <p className='parag'>{announcement.text}</p>
                  </div>
                </Fade>
                <div className='banner__btns d-flex align-items-center'>
                  <a href={announcement.link.url}>
                    <Button
                      onClick={() => {
                        closeBanner()
                      }}
                      type='secondary'
                      to={announcement.link.url}
                      label='Find out more'
                      className='mr-2 pt-1 banner__'
                    />
                  </a>
                  <IconButton onClick={() => closeBanner()} type='close' />
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    ) : null

  return (
    <AnnouncementContext.Provider value={{ visible, closeBanner, Banner }}>
      {children}
    </AnnouncementContext.Provider>
  )
}

const useAnnouncement = () => useContext(AnnouncementContext)

export { AnnouncementProvider, useAnnouncement }
